import gql from "graphql-tag";

export const CREATE_QUOTE = gql`
  mutation AddQuote($data: QuoteDataInput) {
    addQuote(data: $data) {
      id
    }
  }
`;

export const SEND_QUOTE = gql`
  mutation sendQuote($data: SendQuoteDataInput) {
    sendQuote(data: $data) {
      id
    }
  }
`;

export const SEND_DYNAMIC_QUOTE = gql`
  mutation sendDynamicQuote($data: SendDynamicQuoteDataInput) {
    sendDynamicQuote(data: $data) {
      id
    }
  }
`;

export const SEND_TERMINAL_QUOTE = gql`
  mutation sendTerminalQuote($data: SendQuoteDataInput) {
    sendTerminalQuote(data: $data) {
      id
    }
  }
`;

export const SEND_B2C_QUOTE = gql`
  mutation sendB2CQuote($data: SendB2CQuoteDataInput) {
    sendB2CQuote(data: $data) {
      id
    }
  }
`;

export const GENERATE_EXTERNAL_QUOTE = gql`
  mutation GenerateExternalQuote($data: GenerateExternalQuoteDataInput) {
    generateExternalQuote(data: $data) {
      id
      number
      createdDate
      updatedDate
      project {
        id
      }
    }
  }
`;

const quotes = { SEND_QUOTE, SEND_DYNAMIC_QUOTE, SEND_TERMINAL_QUOTE };

export default quotes;
